import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import http from "../../../../services/http.service";
import { toast } from "react-toastify";
import { apiPageLimit } from "../../../../constants/common";

const PROPERTY = `/property`;
const ALL_PROPERTY = `/all-properties`;


export const getPropertyList = createAsyncThunk(
  "getPropertyList",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page = 1, limit = apiPageLimit, search = "", category= "", owner_uuid = "" } = values;
      const response = await http.get(`${PROPERTY}?page=${page}&limit=${limit}&search=${search}&category=${category}&owner_uuid=${owner_uuid}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const propertyDetails = createAsyncThunk(
  "propertyDetails",
  async ({ uuid }: { uuid: any}, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(`${PROPERTY}/${uuid}`);
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to archive user");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const addProperty = createAsyncThunk(
  "addProperty",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.post(`${PROPERTY}`, values);
      toast.success(response?.data?.message || "Property added Successfully.");
      // dispatch(getPropertyList({}));
      return response?.data;
    }
    catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to add property");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const updateProperty = createAsyncThunk(
  "updateProperty",
  async ({ uuid, values }: { uuid: any, values: any }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.put(`${PROPERTY}/${uuid}`, values);
      toast.success(response?.data?.message || "Property updated Successfully.");
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to update property");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const archiveProperty = createAsyncThunk(
  "archiveProperty",
  async ({ uuid, archieve }: { uuid: any, archieve: any }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.put(`${PROPERTY}/${uuid}`, { archieve });
      toast.success(response?.data?.message || "Property archived Successfully.");
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to archive property");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const getPropertyListForFilter = createAsyncThunk(
  "getPropertyListForFilter",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { search = "", owner_uuid = "" } = values;
      const response = await http.get(`${ALL_PROPERTY}?search=${search}&owner_uuid=${owner_uuid}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);